import { Component } from "@angular/core";

@Component({
  template: `
    <h3>Page Not Found</h3>
    <p>Sorry, couldn't find the page you're looking for</p>
  `,
  standalone: false,
})
export class NotFoundView {}
